var map = {
	"./asktug.svg": 70512,
	"./cloud-billing-mauve.svg": 35717,
	"./cloud-dev.svg": 91626,
	"./cloud-developer-mauve.svg": 63206,
	"./cloud-getstarted-mauve.svg": 68561,
	"./cloud-integrations-mauve.svg": 73411,
	"./cloud-learning-mauve.svg": 66788,
	"./cloud-manage-mauve.svg": 86071,
	"./cloud-migrate-mauve.svg": 4107,
	"./cloud-monitor-mauve.svg": 99782,
	"./cloud-product-mauve.svg": 59341,
	"./cloud-reference-mauve.svg": 73179,
	"./cloud-roadmap-mauve.svg": 76424,
	"./cloud-security-mauve.svg": 37352,
	"./cloud-tune-mauve.svg": 12984,
	"./cloud-vector-mauve.svg": 43307,
	"./cloud1.svg": 35001,
	"./cloud2.svg": 9002,
	"./cloud3.svg": 50971,
	"./cloud4.svg": 19348,
	"./cloud5.svg": 64277,
	"./cloud6.svg": 51318,
	"./cloud7.svg": 90855,
	"./contributor.svg": 32808,
	"./deploy.svg": 94872,
	"./doc1.svg": 72494,
	"./doc10.svg": 32514,
	"./doc11.svg": 95155,
	"./doc2.svg": 20845,
	"./doc3.svg": 21900,
	"./doc4.svg": 55795,
	"./doc5.svg": 34274,
	"./doc6.svg": 70993,
	"./doc7.svg": 35040,
	"./doc8.svg": 70871,
	"./doc9.svg": 72838,
	"./docHome.svg": 35484,
	"./events.svg": 70674,
	"./global-iso-hand.svg": 97758,
	"./global-tidb-asktug.svg": 13626,
	"./global-tidb-blog.svg": 85267,
	"./global-tidb-community.svg": 38274,
	"./global-tidb-contribute.svg": 494,
	"./global-tidb-discord.svg": 90389,
	"./global-tidb-ebook.svg": 8007,
	"./global-tidb-education.svg": 44535,
	"./global-tidb-events.svg": 29244,
	"./global-tidb-ossinsight.svg": 35192,
	"./global-tidb-playground.svg": 50868,
	"./global-tidb-product.svg": 23380,
	"./global-tidb-video.svg": 46852,
	"./go.svg": 19395,
	"./home-hero-bg.svg": 17031,
	"./java.svg": 66473,
	"./maintain.svg": 19798,
	"./oss-deploy-blue.svg": 55995,
	"./oss-developer-blue.svg": 60052,
	"./oss-getstarted-blue.svg": 56197,
	"./oss-learning-blue.svg": 8486,
	"./oss-manage-blue.svg": 90227,
	"./oss-migrate-blue.svg": 93691,
	"./oss-monitor-blue.svg": 53304,
	"./oss-mysql-blue.svg": 36020,
	"./oss-product-blue.svg": 64445,
	"./oss-reference-blue.svg": 2111,
	"./oss-roadmap-blue.svg": 43830,
	"./oss-tools-blue.svg": 45933,
	"./oss-tune-blue.svg": 68942,
	"./ossinsight.svg": 66706,
	"./pablo-book-lover.svg": 25836,
	"./papers.svg": 740,
	"./playground.svg": 11574,
	"./python.svg": 67487,
	"./tidb-banner.svg": 96209,
	"./tidb-cloud-banner.svg": 46613,
	"./tidb-cloud-tune.svg": 8761,
	"./users.svg": 87923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87750;